var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLigueMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ligue_me") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Ficha",
    transform: "translate(-1827.000000, -742.000000)",
    stroke: "",
    strokeWidth: 2.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(1794.000000, 403.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy-2",
    transform: "translate(14.000000, 341.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ligue_me",
    transform: "translate(21.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,7 L20,2 L20,7 Z M20,2 L15,2",
    id: "Vector",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(17.500000, 4.500000) rotate(-180.000000) translate(-17.500000, -4.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7245869,19.1620001 C21.5373059,19.5580001 21.2949441,19.9320006 20.9754649,20.2840006 C20.4356552,20.8780006 19.8407614,21.3070009 19.1687534,21.5820009 C18.5077618,21.8570009 17.791689,22 17.0205322,22 C15.8968467,22 14.6960441,21.7360005 13.4291437,21.1970005 C12.1622433,20.6580005 10.8953434,19.932001 9.63945952,19.019001 C8.37255915,18.095001 7.17175761,17.0719997 6.02603903,15.9389997 C4.89133697,14.7949998 3.86680013,13.5960003 2.95242856,12.3420003 C2.0490735,11.0880003 1.32198304,9.83400046 0.793189843,8.59100046 C0.264396647,7.33700048 0,6.13799992 0,4.99399996 C0,4.24599995 0.132198192,3.53100017 0.39659479,2.87100015 C0.660991388,2.20000013 1.07961949,1.58400006 1.66349529,1.03400006 C2.36855288,0.341000068 3.13970983,0 3.9549327,0 C4.26339541,0 4.57185805,0.0660000764 4.84727118,0.198000073 C5.13370082,0.33000007 5.38708099,0.528000021 5.58537845,0.81400001 L8.14121248,4.41100025 C8.33950994,4.68600025 8.48272433,4.93900004 8.58187306,5.18100004 C8.68102179,5.41200003 8.73610479,5.64300019 8.73610479,5.85200019 C8.73610479,6.11600018 8.65898908,6.3799997 8.50475772,6.63299971 C8.3615429,6.88599971 8.15222845,7.14999975 7.88783185,7.41399975 L7.05057569,8.28299971 C6.92939391,8.40399971 6.87431145,8.54700034 6.87431145,8.72300034 C6.87431145,8.81100033 6.88532873,8.88799983 6.90736178,8.97599983 C6.94041136,9.06399983 6.97346085,9.12999962 6.9954939,9.19599962 C7.19379136,9.55899964 7.53530292,10.0320004 8.02003003,10.6040004 C8.51577365,11.1760004 9.04456668,11.7590003 9.61742597,12.3420003 C10.2123183,12.9250003 10.7851778,13.4639996 11.3690536,13.9589995 C11.9419129,14.4429995 12.4156235,14.7729996 12.7901853,14.9709996 C12.845268,14.9929996 12.9113675,15.0259995 12.9884831,15.0589995 C13.0766153,15.0919995 13.1647475,15.1029995 13.2638963,15.1029995 C13.4511772,15.1029995 13.5943918,15.0370005 13.7155736,14.9160005 L14.5528298,14.0910005 C14.8282429,13.8160005 15.0926398,13.607 15.3460199,13.475 C15.5994,13.321 15.852779,13.244 16.1281922,13.244 C16.3375061,13.244 16.5578373,13.2880001 16.8002009,13.3870001 C17.0425644,13.4860001 17.2959454,13.6290005 17.5713585,13.8160005 L21.2178277,16.4009998 C21.5042574,16.5989998 21.702554,16.8299992 21.8237358,17.1049992 C21.933901,17.3799992 22,17.6549999 22,17.9629999 C22,18.3589999 21.9118678,18.7660001 21.7245869,19.1620001 Z",
    id: "Vector",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigueMe);
export default __webpack_public_path__ + "static/media/ligue_me.4eb1cc432aeada50a2329713b6a269aa.svg";
export { ForwardRef as ReactComponent };